import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { XUXDrawerSidebarService } from '@xenial-ux/services';
import { XUXDrawerContainerComponent } from './xux-drawer-container';
import { XUXDrawerContentComponent } from './xux-drawer-content';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { XUXLoaderComponent } from '@xenial-ux/xux-loader';
import { XUXDrawerSidebarComponent } from '@xenial-ux/xux-drawer/xux-drawer-sidebar/xux-drawer-sidebar.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NgMultiSelectDropDownModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        ReactiveFormsModule
    ],
    declarations: [
        XUXDrawerContainerComponent,
        XUXDrawerContentComponent,
        XUXDrawerSidebarComponent,
        XUXLoaderComponent
    ],
    exports: [
        XUXDrawerContainerComponent,
        XUXDrawerContentComponent,
        XUXDrawerSidebarComponent,
        ModalModule,
        XUXLoaderComponent
    ]
})
export class XUXDrawerModule {
    public static forRoot(): ModuleWithProviders<XUXDrawerModule> {
        return {
            ngModule: XUXDrawerModule,
            providers: [XUXDrawerSidebarService]
        };
    }
}
